// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.fees.multifamily.disclaimer.RentalManagerUserMultifamilyCostAndFeesDisclaimerWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  AddMultifamilyFeeDisclaimerRequestDto,
  ListingAlias,
  UpdateMultifamilyFeeDisclaimerRequestDto,
} from '../..';

interface DeleteParams {
  listingAlias: ListingAlias;
}

export const RentalManagerUserMultifamilyCostAndFeesDisclaimerWebApiHandler_create_Path =
  '/api/web/v1/users/properties/fees/multifamily/disclaimer/create';

/**
 * Add a fee disclaimer for a multi family listing
 */
export const RentalManagerUserMultifamilyCostAndFeesDisclaimerWebApiHandler_create = (
  postData: AddMultifamilyFeeDisclaimerRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, AddMultifamilyFeeDisclaimerRequestDto, void>(
    {
      endpoint: RentalManagerUserMultifamilyCostAndFeesDisclaimerWebApiHandler_create_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserMultifamilyCostAndFeesDisclaimerWebApiHandler_delete_Path =
  '/api/web/v1/users/properties/fees/multifamily/disclaimer/delete';

/**
 * Deletes a fee disclaimer for a multi family listing
 */
export const RentalManagerUserMultifamilyCostAndFeesDisclaimerWebApiHandler_delete = (
  getParams: DeleteParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<DeleteParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserMultifamilyCostAndFeesDisclaimerWebApiHandler_delete_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserMultifamilyCostAndFeesDisclaimerWebApiHandler_update_Path =
  '/api/web/v1/users/properties/fees/multifamily/disclaimer/update';

/**
 * Update a fee disclaimer for a multi family listing
 */
export const RentalManagerUserMultifamilyCostAndFeesDisclaimerWebApiHandler_update = (
  postData: UpdateMultifamilyFeeDisclaimerRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UpdateMultifamilyFeeDisclaimerRequestDto, void>(
    {
      endpoint: RentalManagerUserMultifamilyCostAndFeesDisclaimerWebApiHandler_update_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
